import { Container } from '@/components/common/container';
import { AllProductsContent } from '.';

export function AllProductsPage() {
  return (
    <Container>
      <AllProductsContent />
    </Container>
  );
}
